var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.207 3.81a1.11 1.11 0 0 1 0 1.503L8.915 12l6.292 6.686c.39.415.39 1.088 0 1.502a.96.96 0 0 1-1.416 0l-6.998-7.437a1.11 1.11 0 0 1 0-1.502l6.998-7.438a.96.96 0 0 1 1.415-.001",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;